// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"NavigationItems__NavigationItems__3lzpX","Blend":"NavigationItems__Blend__O3QCb","icon":"NavigationItems__icon__1IQSA"};